/*
 * @Author: liang yuhong
 * @Date:   2018-08-17 10:22:14
 * @Last Modified by:   Ding Jianlong
 * @Last Modified time: 2018-09-13 17:37:56
 */
import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const getPage = name => {
  return resolve => require([`@/pages/${name}.vue`], resolve)
}
export default new Router({
  routes: [{
    path: '/',
    name: '',
    meta: {
      title: '会议管理'
    },
    component: getPage('index')
  }, {
    path: '/index',
    name: 'index',
    meta: {
      title: '会议管理'
    },
    component: getPage('index')
  }, {
    path: '/selectRoom',
    name: 'selectRoom',
    meta: {
      title: '会议管理'
    },
    component: getPage('selectRoom')
  }, {
    path: '/editMeeting',
    name: 'editMeeting',
    meta: {
      title: '预约会议'
    },
    component: getPage('editMeeting')
  }, {
    path: '/myMeeting',
    name: 'myMeeting',
    meta: {
      title: '我的会议'
    },
    component: getPage('myMeeting')
  }, {
    path: '/meetInfo',
    name: 'meetInfo',
    meta: {
      title: '会议详情'
    },
    component: getPage('meetInfo')
  },{
    path: '/roomManage',
    name: 'roomManage',
    meta: { 
      title: '会议室管理'
     },
     component: getPage('roomManage')
  }]
})


// WEBPACK FOOTER //
// ./src/router/index.js